import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button } from 'reactstrap';
import renderField from '../../../shared/components/custom/Field';
import ChoiceCards from '../../../shared/components/custom/ChoiceCards';
import FormCard from '../../../shared/components/custom/FormCard';
import InfoBox from '../../../shared/components/custom/InfoBox';
import { partial } from '../../../util/translation/translation';
import { CONNECT_COUNTRIES } from '../connect';

const validate = (values) => {
  const p = partial('connect');
  const errors = {};
  if (!`${values.name || ''}`.trim()) {
    errors.name = p('nameEmpty');
  } else if (values.name.trim().length > 100) {
    errors.name = p('nameTooLong');
  }
  if (!CONNECT_COUNTRIES.includes(values.country)) {
    errors.country = p('countryEmpty');
  }
  return errors;
};

// A new receiver: the club's Stripe account is created with it, and the
// page sends the admin on to Stripe's onboarding right after
const ConnectReceiverForm = ({
  handleSubmit,
  initialize,
  defaultName,
  defaultCountry,
  isFirst,
  onCancel,
}) => {
  const p = partial('connect');
  useEffect(() => {
    initialize({ name: defaultName || '', country: defaultCountry });
    // initialize is a stable redux-form dispatch
    // eslint-disable-next-line
  }, [defaultName, defaultCountry]);
  const countryOptions = CONNECT_COUNTRIES.map((country) => ({
    value: country,
    label: p(`country-${country}`),
    hint: p(`currency-${country}`),
  }));

  return (
    <form onSubmit={handleSubmit} className="form settings-form">
      <FormCard title={isFirst ? p('getStarted') : p('addReceiver')}>
        {isFirst && <p className="mb-3">{p('getStartedText')}</p>}
        <div className="form__form-group">
          <span className="form-header">{p('receiverName')}</span>
          <Field
            name="name"
            component={renderField}
            placeholder={p('receiverName')}
          />
          <span className="settings-form__help">{p('receiverNameHelp')}</span>
        </div>
        <div className="form__form-group">
          <span className="form-header">{p('country')}</span>
          <Field
            name="country"
            component={ChoiceCards}
            options={countryOptions}
            ariaLabel={p('country')}
          />
        </div>
        <InfoBox>{p('onboardingInfo')}</InfoBox>
        <div className="form-card__actions">
          <Button type="submit" color="primary" size="sm">
            {p('createAndStart')}
          </Button>
          {onCancel && (
            <Button type="button" outline size="sm" onClick={onCancel}>
              {p('cancel')}
            </Button>
          )}
        </div>
      </FormCard>
    </form>
  );
};

ConnectReceiverForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  defaultName: PropTypes.string,
  defaultCountry: PropTypes.oneOf(CONNECT_COUNTRIES).isRequired,
  isFirst: PropTypes.bool,
  onCancel: PropTypes.func,
};

ConnectReceiverForm.defaultProps = {
  defaultName: '',
  isFirst: true,
  onCancel: undefined,
};

export default reduxForm({
  form: 'connect_receiver_form',
  validate,
})(ConnectReceiverForm);
